import { Button } from 'components/Button/Button';
import { Modal } from 'components/Modal/Modal';
import { Portal } from 'components/Portal/Portal';
import { useTranslation } from 'react-i18next';

export const RemoveFoodModal = ({ isOpen, onResolve, onReject, food }: any) => {
    const { t } = useTranslation('member', { keyPrefix: 'preferences' });

    return (
        <Portal>
            <Modal isOpen={isOpen} onClose={onReject} maxWidth={512} uncloseable>
                <div className="flex flex-col gap-4">
                    <div>
                        <div className="text-xl font-semibold text-zinc-700 mb-2">
                            {t('removeModalTitle').replace('{food}', food)}
                        </div>
                        <div className="text-sm text-zinc-500">{t('removeModalSubtitle')}</div>
                    </div>
                    <div className="flex justify-end gap-2">
                        <Button variant="outline" onClick={onReject}>
                            {t('removeModalCancel')}
                        </Button>
                        <Button onClick={onResolve}>{t('removeModalConfirm')}</Button>
                    </div>
                </div>
            </Modal>
        </Portal>
    );
};
